import axios from "axios";

async function addArticle (currentUser, id, partValue, stockState, setStockState) {
    await axios({
        method: 'post', 
        url: process.env.REACT_APP_SERVER_NAME,
        params: {st: 'update'},
        data: {
            user_email: currentUser.email,
            user_teamUid: currentUser.teamUid,
            user_role: currentUser.role,
            action: "changeValues",
            article: {
                id: partValue.id,
                ref: partValue.ref,
                des: partValue.des,
                cat: partValue.cat,
                cats: partValue.cats,
                quant: partValue.quant,
                quantMini: partValue.quantMini,
                delay: partValue.delay,
                prov: partValue.prov,
                provRef: partValue.provRef,
                price: partValue.price
            },
            filter: {
                column: stockState.filter.column,
                value: stockState.filter.value,
                minQuant: stockState.filter.minQuant
            },
            paginator: {
                page: stockState.page,
                perPage: stockState.perPage
            }
        },
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + currentUser.token
        }
    }).then((resp) => {
        if (resp.status === 200) {
            setStockState({
                ...stockState,
                addMode: false,
                totalParts: resp.data.totalParts,
                stock: resp.data.stockAsked,
                old_message: stockState.message,
                message: resp.data.message
            });
        }
    })
}
export default addArticle;